import { Icon, ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { ViewWithSeparators } from 'components/ViewWithSeparators';

import { theme } from 'lib/theme';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

type Props = {
  questions: number;
  questionsCompleted: number;
  checklists: number;
  checklistsCompleted: number;
  actions: number;
  controls: number;
  unreviewedActions: number;
  unreviewedControls: number;
  style?: StyleProp<ViewStyle>;
};

export const CountChips: React.FC<Props> = ({
  questions,
  questionsCompleted,
  checklists,
  checklistsCompleted,
  actions,
  controls,
  unreviewedActions,
  unreviewedControls,
  style,
}) => {
  if (
    !questions &&
    !checklists &&
    !actions &&
    !controls &&
    !unreviewedActions &&
    !unreviewedControls
  ) {
    return null;
  }

  return (
    <ViewWithSeparators
      horizontal
      separatorColor="transparent"
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 10,
          overflow: 'hidden',
        },
        style,
      ]}
    >
      <View style={{ width: 5 }} />
      {!!questions && (
        <View style={styles.chipOuter}>
          <View
            style={[
              styles.chipInner,
              {
                backgroundColor: theme.colors.question,
                borderColor: theme.colors.question,
              },
            ]}
          >
            <Icon source={ICONS.CircleQSolid} color={theme.colors.white} />
            <Txt
              size="xsmall"
              numberOfLines={1}
              style={{
                color: theme.colors.white,
                marginLeft: theme.padding / 3,
                marginRight: theme.padding / 2,
              }}
            >
              {questionsCompleted === questions
                ? questions
                : `${questionsCompleted}/${questions}`}
            </Txt>
          </View>
        </View>
      )}
      {!!checklists && (
        <View style={styles.chipOuter}>
          <View
            style={[
              styles.chipInner,
              {
                backgroundColor: theme.colors.checklist,
                borderColor: theme.colors.checklist,
              },
            ]}
          >
            <Icon source={ICONS.CircleCSolid} color={theme.colors.white} />
            <Txt
              size="xsmall"
              style={{
                color: theme.colors.white,
                marginLeft: theme.padding / 3,
                marginRight: theme.padding / 2,
              }}
            >
              {checklistsCompleted === checklists
                ? checklistsCompleted
                : `${checklistsCompleted}/${checklists}`}
            </Txt>
          </View>
        </View>
      )}
      {(!!actions || !!unreviewedActions) && (
        <View style={styles.chipOuter}>
          <View
            style={[
              styles.chipInnerFinding,
              {
                backgroundColor: theme.colors.assessmentAction,
              },
            ]}
          >
            <Txt
              size="xsmall"
              style={{
                color: theme.colors.white,
              }}
            >
              {actions}
              {unreviewedActions ? `/${actions + unreviewedActions}` : ''}
            </Txt>
          </View>
        </View>
      )}
      {(!!controls || !!unreviewedControls) && (
        <View style={styles.chipOuter}>
          <View
            style={[
              styles.chipInnerFinding,
              {
                backgroundColor: theme.colors.assessmentControl,
              },
            ]}
          >
            <Txt
              size="xsmall"
              style={{
                color: theme.colors.white,
                textAlign: 'center',
              }}
            >
              {controls}
              {unreviewedControls ? `/${controls + unreviewedControls}` : ''}
            </Txt>
          </View>
        </View>
      )}
    </ViewWithSeparators>
  );
};

const styles = StyleSheet.create({
  chipOuter: {
    borderRadius: 10,
    backgroundColor: 'white',
    marginLeft: -5,
    borderWidth: 1,
    borderColor: 'white',
  },
  chipInner: {
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    height: 21,
  },
  chipInnerFinding: {
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 21,
    minWidth: 21 + theme.paddingHorizontalHalf,
    paddingHorizontal: theme.paddingHorizontalHalf,
  },
});
